import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";

const RUNGS = [
  { price: "₹9", label: "The hook", desc: "Cheap enough to say yes without thinking. Three hours of what you already knew.", w: "sm:w-[46%]" },
  { price: "₹299", label: 'The "detailed" class', desc: "One-day validity. 100 seats. Ends tonight. Still just the basics, slightly repackaged.", w: "sm:w-[60%]" },
  { price: "₹3,000", label: 'The "real" course', desc: "Now it's serious money — for content the free version already implied.", w: "sm:w-[74%]" },
  { price: "₹40,000", label: 'The "mentorship"', desc: "The final rung. By now you've paid four times chasing value that was never on any of them.", w: "sm:w-[88%]" },
];

export const Ladder = () => (
  <section data-testid="ladder-section" className="py-24 sm:py-32 bg-white border-y border-black/5">
    <div className="max-w-6xl mx-auto px-6">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.6 }}
        className="max-w-2xl"
      >
        <div className="flex items-center gap-4">
          <span className="font-display text-4xl sm:text-5xl font-bold outline-word leading-none select-none" aria-hidden="true">02</span>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-trust">The playbook</p>
        </div>
        <h2 className="mt-4 font-display text-4xl sm:text-5xl font-bold tracking-tight leading-tight">
          It's not random. It's a ladder — and you're the one climbing it.
        </h2>
        <p className="mt-4 text-base sm:text-lg text-gray-600">
          The exact same funnel runs across courses, design bundles, prompt packs and "mentorships." Once you see
          it, you can't unsee it.
        </p>
      </motion.div>

      <div className="mt-16 space-y-5">
        {RUNGS.map((r, i) => (
          <motion.div
            key={r.price}
            data-testid={`ladder-rung-${i}`}
            className={`${r.w} relative rounded-2xl border border-black/5 bg-paper p-6 sm:p-7 shadow-[0_10px_30px_-14px_rgba(17,24,39,0.15)] flex items-center gap-5 sm:gap-8`}
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.55, delay: i * 0.12 }}
          >
            <div className="font-display text-2xl sm:text-4xl font-bold tracking-tight text-warn shrink-0 w-24 sm:w-36">
              {r.price}
            </div>
            <div>
              <p className="font-display font-semibold text-base sm:text-lg">{r.label}</p>
              <p className="mt-1 text-xs sm:text-sm text-gray-600">{r.desc}</p>
            </div>
            {i < RUNGS.length - 1 && (
              <span className="absolute -bottom-5 left-10 sm:left-16 z-10 w-7 h-7 rounded-full bg-warn-soft text-warn flex items-center justify-center">
                <ArrowDown size={14} />
              </span>
            )}
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
